import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // get dashboard state data
  getDashboardStateData: async ({ commit }) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/dashboard')

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // set customer
      commit('SET_STATE', {
        action: 'stat_data',
        data: res.data.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // recently added items
  getRecentAddedData: async ({ commit }) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/dashboard/recently-added-items')

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // set customer
      commit('SET_STATE', {
        action: 'recently_added_items',
        data: res.data.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // stock alerts
  getStockAlerts: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    const { limit, page, order } = payload

    try {
      const res = await axios.get('/dashboard/stock-alert', {
        params: {
          limit,
          page,
          order
        }
      })

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // set customer
      commit('SET_STATE', {
        action: 'stock_alerts',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get annoucement message
  getAnnouncement: async ({ commit }) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/dashboard/dashboard-announcement')

      commit('SET_STATE', {
        action: 'announcement_msg',
        data: res.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    } finally {
      // set loading - off
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
    }
  },

  // announcement message
  updateAnnouncement: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.put('/dashboard/dashboard-announcement', payload)

      commit('SET_STATE', {
        action: 'announcement_msg',
        data: res.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    } finally {
      // set loading - off
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
    }
  },

  getTagList: async (_, payload) => {
    try {
      const res = await axios.get('/dashboard/get-tags', {
        params: {
          ...payload
        }
      })

      return {
        data: res.data.data,
        total: res.data.totalCount,
        filteredCount: res.data.FilteredCount
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
